<template>
<main class="c-home u-viewport-fit-h u-overflow-h u-bg--brand-dark is-first" >
     <app-home-slide  inline-template  data-color="clear" class="c-home__section o-wrapper--valign u-flex u-flex-ai--center u-flex-jc--center u-fit u-overflow-h u-bg--black"       :content="content"       :headerPageSize="headerPageSize"   :activeIndex="activeIndex"   :navOffsetTop="navOffsetTop"     :indexSS="0"   :hasVideo="!1"  >
            <div class="o-wrapper--valign u-fit u-bg--white" >
              <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--x u-absolute u-fit-w u-bg--brand-dark u-hide@sm"></div>
              <div class="c-home__section__bar c-home__section__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark u-hide@sm"></div>
              <div class="o-wrapper--panel u-zindex--1 u-fit u-bg--black">
               <div class="c-home__section__poster__filter u-absolute u-pos-tl u-zindex--1 u-fit" style="background-color: rgb(255, 255,255);"> </div>
               </div>
               <div class="u-absolute u-pos-tl  u-marg-t-mdvh   u-marg-t-mdvh@sm  u-zindex--3 u-marg-l-w1of6s u-marg-l-w2of8@sm u-marg-l-w3of8@xsm" >
                 <div class="u-w2of2 u-fit-w@md">
                        <div class="u-flex t-text--sm t-text--base-bold c-Home--title-lheigt ">
                            <!--<span class="t-h2 c-page__subtitle t-text--base-bold  t-text-lh--md   u-color--white">{{content.third_slide_title}}</span>-->
                         </div>
                     </div>
               </div>

               <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none"></div>
                    <div class="c-home__section__fade u-relative u-zindex--3 u-flex u-flex-fd--column@md u-w9of12 u-w9of12@md u-fit-w@sm u-pad-x-w1of12@sm u-pad-x-w0of0@sm">
                          <div class="c-team__content  u-marg-t-xs@lg u-marg-t-xs@sm u-w2of2 u-w3of4@xsm u-marg-x-w1of12@sm u-w9of10@md  u-w9of10lg u-marg-t-xxl@sm" >
                              <section class="u-relative js-header-panel" data-color="clear">
                                <div class="c-team__section-container u-relative u-pad-r-w1of12 u-pad-y-xxl@md u-pad-y-lg@sm u-pad-x-w0of0@sm">
                                    <div class="c-team__section u-marg-t-lg u-marg-t-xl@lg u-marg-t-xs@sm">
                                          <div class="u-flex u-flex-fw--wrap u-marg-l-w1of6@550sm u-flex-jc--space-between">
                                                  <router-link class="c-team__link c-subsidiries__link t-link  u-marg-r-sub--wmax@xl u-marg-r-sub--wmin@sm u-marg-r-cov--wmax@lg u-marg-r-sub--wmax@fullHD u-marg-top-min--subsi@xsm"  :to="item.websiteurl"  v-for="(item, index)  in content.product_sections[0].PRODUCTS"  :data-index="index" :key="index"  @mouseenter="onHoverPopin((item.first_name + item.last_name).replace(/\s/g,''),index)" @mouseleave="onHoverOutPopin((item.first_name+item.last_name).replace(/\s/g,''),index)" >
                                                   <div class="c-team__link__photo-container js-photo-container u-relative o-box--14by10 u-marg-b-md-minus u-overflow-h u-force-3d is-loading" >
                                                           <div class="u-absolute u-pos-t u-zindex--2"></div>
                                                           <img class="c-team__link__photo__hover u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden fade-leave-to" :id="('hover'+item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium_large"  @load="_onLoadMemberImage(index)"></img>
                                                           <img class="c-team__link__photo u-zindex--1 o-wrapper--panel u-fit u-object-fit-cover u-backface-hidden" :id="(item.first_name + item.last_name).replace(/\s/g,'')"  :src="item.image.sizes.medium"       @load="_onLoadMemberImage(index)"></img>
                                                   </div>
                                                   <div class="u-pad-r-sm"></div>

                                                  </router-link>
                                          </div>
                                    </div>
                                </div>
                              </section>
                          </div>
                    </div>




                  </div>
              </app-home-slide>



</main>
</template>

<script>
import appHomeSlide from '../app-home-slide/index.vue'
export default
{
    props:
    {
      debug:
      {
          type: Boolean,
          default: !1
      },
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        },
        isPopinActive:
        {
          type:Boolean,
          default: !1
        }
    },
    components: {
        'app-home-slide':appHomeSlide
},
    mixins: [],
    data: function() {
        return {
            activeIndex: 0,
            activeRollOverIndex: 0,
            navHeight: 0,
            navOffsetTop: 0
        }
    },
    computed:
    {
        content: function() {
            return this.adminContent.en.pages.products
        },
        myStylesNavHeight() {
            return {
                height: this.navHeight+'px',
                width:'70px'
            }
        },
        myStylesTransform1() {
            return {
                transform: 'translateY('+100*this.activeRollOverIndex+') translateZ(0) ',

            }
        }
    },
    created: function()
    {

            this.PIXEL_STEP = 10,
            this.LINE_HEIGHT = 40,
            this.PAGE_HEIGHT = 800,
            this.NBSLIDE = 6,
            this._isWheeling = !1,
            this._isPointerDown = !1,
            this._pointerY = 0,
            this._pointerStartY = 0,
            this.eventHub.$on("resize", this.onResize),
            this.eventHub.$emit("hide:header")

    },
    destroyed: function()
    {
        this.eventHub.$off("resize", this.onResize)

    },
    mounted: function()
    {

            this.eventHub.$emit("page:ready"),

            this.onResize()

    },
    methods:
    {

        onResize: function()
        {

        },



    }
}

</script>
<style  scoped>

</style>
